import React from 'react'
import Header3 from '../LandingPage/Header3';
import { MimaButton, MimaText } from '../../components';
import styles from '../../assets/styles/Blog/Blog.module.scss';
import Footer from '../LandingPage/Footer';
import PlayStoreIcon from '../../assets/img/playstore.png';
import AppleStoreIcon from '../../assets/img/apple.png';
import styles2 from '../../assets/styles/LandingPage/Header.module.scss';
import { IoArrowForward } from 'react-icons/io5';
import { Link } from 'react-router-dom';

const BlogSingle = ({ blogPost, relatedPost, switchToSignup }) => {

    const appleIcon = <img src={AppleStoreIcon} className={styles2.btn__icon} alt="download Mima Business on ios" />;

    const playIcon = <img src={PlayStoreIcon} className={styles2.btn__icon} alt="download Mima Business on android" />;

    return (
        <>
            <Header3 />
            <div className={styles.title}>
                <MimaText variant="h2" mb={1}>{blogPost.title}</MimaText>
                <div className={styles.single__author}>

                    {blogPost.tags.map((x) => (
                        <div className={styles.blog__list__single__tags}>
                            {x}
                        </div>
                    ))}
                    <MimaText variant="bodyBold">{blogPost.author}</MimaText>
                    <MimaText variant="body2">{blogPost.creationDate}</MimaText>
                    <MimaText variant="body2">{blogPost.readTime} read</MimaText>
                </div>
            </div>
            <div className={styles.single}>
                <img src={blogPost.titleImage} alt={blogPost.title} className={styles.single__img} />
                <div className={styles.single__content}>
                    <div className={styles.single__content__1}>
                        <MimaText variant="h3" color="var(--color-white)" mb={3}>Get the Mima Business App on your phone</MimaText>
                        <MimaText variant="body2" color="var(--color-white)">Your All-in-One Business Solution! Simplify, Grow, and Thrive.</MimaText>
                        <div className='{styles.slide__text_btn}'>
                            <a href='https://play.google.com/store/apps/details?id=com.mima.mima' style={{ textDecoration: "none" }}>
                                <MimaButton
                                    title="Get app on Android"
                                    icon={playIcon}
                                    variant="formColorable"
                                    buttonColor="var(--color-white)"
                                    titleColor="var(--color-dark)"

                                />
                            </a>

                            <a href='https://apps.apple.com/us/app/mima-business/id6444887331' style={{ textDecoration: "none" }}>

                                <MimaButton
                                    title="Get app on iPhone"
                                    variant="formColorable"
                                    icon={appleIcon}
                                    buttonColor="var(--color-white)"
                                    titleColor="var(--color-dark)"
                                />
                            </a>


                        </div>

                    </div>
                    <div className={styles.single__content__2}>
                        {
                            blogPost.content.map((item, i) => (
                                <div key={i}>
                                    {item.sectionTitle && <MimaText variant="h3" mb={2}>{item?.sectionTitle}</MimaText>}
                                    {item.sectionContent && <MimaText variant="body2" mb={3}>{item?.sectionContent}</MimaText>}
                                    {item.subSection && item.subSection.map((x, i) => (
                                        <MimaText key={i} variant="body2" mb={3}>
                                            <span style={{ fontWeight: "700" }}>{x?.subSectionTitle}</span> {x?.subSectionContent}
                                        </MimaText>
                                    ))}
                                    <div style={{ marginBottom: "3rem" }}>
                                        {item.sectionList && item.sectionList.map((x, i) => (
                                            <li key={i}>
                                                {x}
                                            </li>
                                        ))}
                                    </div>

                                </div>
                            ))
                        }
                    </div>
                </div>

            </div>
            <MimaText variant="subtitle" ml={3} mb={3} mt={3} align="left"> <span style={{ fontWeight: "700", cursor: "pointer", color: "var(--color-primary)" }} onClick={switchToSignup}>CLICK HERE</span> to sign up today and start enjoying the benefits of Mima Business.</MimaText>
            <div className={styles.title}>
                <MimaText variant="h2" mb={3}>Related Articles</MimaText>
                <MimaText variant="body2" mb={2}>View related articles here</MimaText>
                <div className={styles.blog__list}>
                    {relatedPost.map((blog) => (
                        <Link to={blog.link}>
                            <div key={blog._id} className={styles.blog__list__single}>
                                <div className={styles.blog__list__single__img__container}>
                                    <img src={blog.titleImage} alt={blog.title} className={styles.blog__list__single__img} />
                                </div>

                                <div className={styles.blog__list__single__flex}>
                                    <div className={styles.blog__list__single__tags}>
                                        {blog.tags.map((x) => (
                                            <div>
                                                {x}
                                            </div>
                                        ))}
                                    </div>
                                    <MimaText variant="small">
                                        {blog.readTime} Read
                                    </MimaText>
                                </div>
                                <MimaText variant="subtitleBold">
                                    {blog.title}
                                </MimaText>
                                <MimaText>
                                    {blog.summary}
                                </MimaText>
                                <div className={styles.blog__list__single__read}>
                                    Read More <IoArrowForward />
                                </div>

                            </div>
                        </Link>

                    ))}

                </div>
            </div>


            <Footer />
        </>
    )
}

export default BlogSingle